import React, { Component } from 'react';
import Select from 'react-select';
import classnames from 'classnames';
import CategoryItemIcon from "../Category-item/Category-item-icon/CategoryItemIcon";
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

class MobileCategoryItem extends Component {
  render() {
    const {
      cat,
      OnSelectCar,
      selectedCar,
      placeholder,
      translate,
      input: { value, onChange, onBlur }
    } = this.props;
    return (
      <div className="mobCatItem">
        <Select
          searchable={false}
          clearable={false}
          className="mobCalcSelect"
          value={value}
          placeholder={translate(placeholder)}
          onChange={s => {
            const value =
              s !== null
                ? Array.isArray(s) ? s.map(o => o.value) : s.value
                : '';
            onChange(value);
          }}
          options={cat.map(item => {
            return { value: item.id, label: translate(item.number)}
          })}
          onBlur={() => {
            onBlur(value);
          }}

          // name={name}
          // placeholder={''}
          // value={value}
          // onChange={s => {
          //   const value =
          //     s !== null
          //         ? Array.isArray(s) ? s.map(o => o.value) : s.value
          //         : '';
          //             onChange(value);
          //         }}
          // onBlur={() => {
          //             onBlur(value);
          //         }}
          //         openOnFocus={true}
        />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
});
export default connect(mapStateToProps)(MobileCategoryItem) ;





// WEBPACK FOOTER //
// ./src/components/Calculator-board/Mobile-Category-Item/MobileCategoryItem.js